class XMEnum {
    constructor(arr) {
        if (!Array.isArray(arr)) {
            throw 'arr必须为数组!';
            return;
        }
        arr.map(item => {
            this[item.name] = item;
        });
    }
}

export default XMEnum;


// WEBPACK FOOTER //
// ./src/enum/XMEnum.js